import { Link } from "react-router-dom";
import { Wallet, PauseCircle } from "lucide-react";

const eur = (n) => (n || 0).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
const fr = (d) => (d ? new Date(`${d.slice(0, 10)}T12:00:00`).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" }) : "—");

const Card = ({ icon: I, title, right, children, testid }) => (
  <div className="bg-white border border-slate-200 rounded-md p-5" data-testid={testid}>
    <div className="flex items-center gap-2 mb-3"><I className="h-5 w-5" /><h2 className="font-display font-bold text-lg">{title}</h2><span className="ml-auto">{right}</span></div>
    {children}
  </div>
);

export function CollectionsPanel({ d }) {
  const tc = d.to_collect || { items: [], total_ttc: 0 };
  const sus = d.suspended_list || [];
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <Card icon={Wallet} title="À encaisser cette semaine" testid="to-collect-card" right={<b className="font-display text-lg" data-testid="to-collect-total">{eur(tc.total_ttc)} TTC</b>}>
        {tc.items.length ? <div className="divide-y divide-slate-100">{tc.items.map((x) => (
          <Link key={x.id} to={`/super/facturation?edit=${x.id}`} className="flex items-center gap-3 py-2.5 px-1 rounded hover:bg-slate-50 transition-colors" data-testid={`to-collect-${x.id}`}>
            <span className="flex-1 min-w-0"><span className="block text-sm font-semibold truncate">{x.client?.name}</span><span className="block text-xs text-slate-500 font-mono">{x.number}</span></span>
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${x.overdue ? "bg-rose-100 text-rose-700" : "bg-amber-100 text-amber-800"}`}>{x.overdue ? "En retard · " : "Échéance "}{fr(x.due_date)}</span>
            <span className="text-sm font-bold w-28 text-right">{eur(x.total_ttc)}</span>
          </Link>))}</div> : <p className="text-sm text-slate-500" data-testid="to-collect-empty">Aucune facture à encaisser d'ici 7 jours.</p>}
      </Card>
      <Card icon={PauseCircle} title="Comptes suspendus" testid="suspended-card" right={<b className="font-display text-lg" data-testid="suspended-count">{sus.length}</b>}>
        {sus.length ? <div className="divide-y divide-slate-100">{sus.map((c) => (
          <Link key={c.id} to="/super/entreprises" className="flex items-center gap-3 py-2.5 px-1 rounded hover:bg-slate-50 transition-colors" data-testid={`suspended-${c.id}`}>
            <span className="flex-1 min-w-0"><span className="block text-sm font-semibold truncate">{c.name}</span><span className="block text-xs text-slate-500 truncate">{c.reason || "Suspension manuelle"}</span></span>
            {c.unpaid && <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-rose-100 text-rose-700">Impayé</span>}
            <span className="text-xs text-slate-500">depuis le {fr(c.since)}</span>
          </Link>))}</div> : <p className="text-sm text-slate-500" data-testid="suspended-empty">Aucun compte suspendu.</p>}
      </Card>
    </div>
  );
}
